module.exports = __webpack_public_path__ + "img/subportionplaceholder.9c4d1593.jpg";